import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BUSINESS } from "@/lib/api";

const navItems = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/booking", label: "Book a Service", testid: "nav-booking" },
  { to: "/specials", label: "Specials", testid: "nav-specials" },
  { to: "/join", label: "Join the Team", testid: "nav-join" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo-link"
          className="flex items-center gap-2 group"
        >
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-slate-900 overflow-hidden group-hover:ring-2 group-hover:ring-blue-700/30 transition">
            <img
              src="/phoenix-icon.png"
              alt=""
              className="h-full w-full object-cover"
            />
          </span>
          <span className="pf-heading text-lg font-semibold tracking-tight text-slate-900">
            The Phoenix Fix
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-slate-900" : "text-slate-500 hover:text-slate-900"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/admin/login"
            data-testid="nav-admin"
            className="text-xs uppercase tracking-[0.18em] text-slate-400 hover:text-slate-700"
          >
            Admin
          </Link>
        </nav>

        <div className="hidden md:block">
          <Link
            to="/booking"
            data-testid="nav-cta-book"
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-semibold hover:bg-blue-700 transition-colors"
          >
            Book Now
          </Link>
        </div>

        <button
          className="md:hidden p-2 text-slate-700"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={`${item.testid}-mobile`}
                className={({ isActive }) =>
                  `text-base font-medium ${
                    isActive ? "text-slate-900" : "text-slate-600"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/admin/login"
              onClick={() => setOpen(false)}
              data-testid="nav-admin-mobile"
              className="text-xs uppercase tracking-[0.18em] text-slate-400"
            >
              Admin
            </Link>
            <Link
              to="/booking"
              onClick={() => setOpen(false)}
              data-testid="nav-cta-book-mobile"
              className="inline-flex items-center justify-center px-5 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-semibold"
            >
              Book Now
            </Link>
            <a
              href={BUSINESS.phoneHref}
              data-testid="nav-phone-mobile"
              className="text-sm text-slate-600"
            >
              {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}

      {/* Visual hack: avoid unused var warning */}
      <span className="hidden" data-current-path={location.pathname} />
    </header>
  );
}
